import * as React from 'react';
import strings from './strings';
import { FormattedCurrency } from '../common/FormattedCurrency';
import DetailsCard from '../common/DetailsCard';
import { buildClassString } from '../../StringUtils';
import { normalizePayRange } from '../common/Helpers';
import './style/index.scss';
export class RangePenetrationCard extends React.PureComponent {
    render() {
        const { pay, rangeMin, rangeMax } = this.props;
        const hasPay = pay != null;
        const hasValidData = rangeMin != null && rangeMax != null;
        const penetrationValue = hasPay ? this._getRangePenPercentage() : 0;
        const labelRight = penetrationValue < 50;
        const positionStyle = this._computeLabelPositionStyle(penetrationValue, labelRight);
        const vizClass = buildClassString({
            'range-penetration-card__viz': true,
            'invalid': !hasValidData,
            'hide-thumb': !hasPay || !hasValidData
        });
        return (React.createElement(DetailsCard, { className: "range-penetration-card", title: strings.cardTitle },
            React.createElement("div", { className: "range-penetration-card__blurb" }, strings.blurb),
            React.createElement("div", { className: vizClass },
                React.createElement("div", { className: "range-penetration-card__viz-bar-container" },
                    React.createElement("div", { className: "range-penetration-card__viz-bar" },
                        React.createElement("div", { "data-mf-replace-inner": "***", className: "range-penetration-card__viz-thumb-label", style: positionStyle },
                            penetrationValue,
                            "%")),
                    React.createElement("div", { className: "range-penetration-card__viz-thumb-container", style: positionStyle },
                        React.createElement("div", { className: "range-penetration-card__viz-thumb-hack" },
                            React.createElement("div", { className: "range-penetration-card__viz-thumb" })))),
                this._renderVizLabels())));
    }
    _getRangePenPercentage() {
        const { pay, isHourlyPay, rangeMin, rangeMax, isHourlyRange } = this.props;
        const payRange = normalizePayRange(pay, isHourlyPay, rangeMin, rangeMax, isHourlyRange);
        const range = payRange.rangeMax - payRange.rangeMin;
        if (range === 0 || !pay) {
            return 0;
        }
        return Math.round((pay - payRange.rangeMin) / range * 100);
    }
    _computeLabelPositionStyle(penetrationValue, positionRight) {
        const pinnedPenetrationValue = Math.max(0, Math.min(penetrationValue, 100));
        return {
            left: `${pinnedPenetrationValue}%`,
            transform: positionRight ? undefined : 'translateX(-100%)'
        };
    }
    _renderVizLabels() {
        const { pay, isHourlyPay, rangeMin, rangeMax, isHourlyRange, currency, currencyFormatter } = this.props;
        const payRange = normalizePayRange(pay, isHourlyPay, rangeMin, rangeMax, isHourlyRange);
        const hasRange = payRange.rangeMin != null && payRange.rangeMax != null;
        return (React.createElement("div", { className: "range-penetration-card__range-labels" },
            React.createElement("div", { className: "range-penetration-card__range-min" },
                React.createElement("span", null,
                    strings.min,
                    "\u00A0",
                    hasRange &&
                        React.createElement(FormattedCurrency, { val: payRange.rangeMin, currency: currency, formatFunc: currencyFormatter }))),
            React.createElement("div", { className: "range-penetration-card__range-max" },
                React.createElement("span", null,
                    strings.max,
                    "\u00A0",
                    hasRange &&
                        React.createElement(FormattedCurrency, { val: payRange.rangeMax, currency: currency, formatFunc: currencyFormatter })))));
    }
}
export default RangePenetrationCard;
